import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Twitter, Youtube, Mail, ArrowRight } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="relative mt-32 border-t border-bone-100/8 bg-ink-950" data-testid="site-footer">
      <div className="absolute inset-x-0 top-0 h-px divider-gold" />
      <div className="container-x py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        {/* Brand */}
        <div className="md:col-span-4 space-y-6">
          <Link to="/" className="block">
            <span className="font-display italic text-3xl text-bone-50">sip theory</span>
            <span className="block text-[10px] tracking-[0.42em] text-bone-300 mt-1">BEVERAGES</span>
          </Link>
          <p className="text-bone-300/90 text-sm leading-relaxed max-w-sm">
            Crafted with real ingredients and honest recipes — to nourish your body and elevate your everyday.
          </p>

          {/* Newsletter */}
          <form
            data-testid="newsletter-form"
            className="flex items-center glass-soft p-1.5 pl-5 rounded-full max-w-md"
            onSubmit={(e) => e.preventDefault()}
          >
            <Mail className="w-4 h-4 text-bone-300 mr-3" />
            <input
              type="email"
              placeholder="Your email for the morning ritual"
              className="bg-transparent flex-1 text-sm placeholder:text-bone-300/60 outline-none py-2"
              data-testid="newsletter-input"
            />
            <button type="submit" className="btn-primary !py-2 !px-4 !text-[11px]" data-testid="newsletter-submit">
              Join <ArrowRight className="w-3.5 h-3.5" />
            </button>
          </form>
        </div>

        {/* Link columns */}
        <FooterCol title="Shop" links={[
          { to: '/shop?cat=shakes', label: 'Shakes' },
          { to: '/shop?cat=fruit-shakes', label: 'Fruit Shakes' },
          { to: '/shop?cat=cold-coffee', label: 'Cold Coffee' },
          { to: '/shop?cat=water-range', label: 'Water Range' },
          { to: '/shop?cat=chaas-range', label: 'Chaas Range' },
        ]} />
        <FooterCol title="Company" links={[
          { to: '/our-story', label: 'Our Story' },
          { to: '/collections', label: 'Collections' },
          { to: '/b2b', label: 'B2B & Wholesale' },
          { to: '/blog', label: 'Journal' },
          { to: '/contact', label: 'Contact' },
        ]} />
        <FooterCol title="Support" links={[
          { to: '/contact', label: 'Help Center' },
          { to: '/contact', label: 'Shipping & Returns' },
          { to: '/contact', label: 'Storage Guide' },
          { to: '/contact', label: 'Privacy Policy' },
          { to: '/contact', label: 'Terms of Service' },
        ]} />
      </div>

      <div className="container-x pb-10 flex flex-col md:flex-row gap-6 items-center justify-between border-t border-bone-100/8 pt-8">
        <p className="text-xs text-bone-300/70">© {new Date().getFullYear()} Sip Theory Beverages. All rights reserved.</p>
        <div className="flex items-center gap-3" data-testid="footer-social">
          <SocialLink icon={<Instagram className="w-4 h-4" />} href="#" label="Instagram" />
          <SocialLink icon={<Facebook className="w-4 h-4" />} href="#" label="Facebook" />
          <SocialLink icon={<Twitter className="w-4 h-4" />} href="#" label="Twitter" />
          <SocialLink icon={<Youtube className="w-4 h-4" />} href="#" label="Youtube" />
        </div>
      </div>
    </footer>
  );
}

const FooterCol = ({ title, links }) => (
  <div className="md:col-span-2.5 space-y-4">
    <h4 className="text-xs tracking-[0.32em] uppercase text-gold font-medium">{title}</h4>
    <ul className="space-y-2.5">
      {links.map((l, i) => (
        <li key={i}>
          <Link to={l.to} className="text-sm text-bone-200/85 hover:text-gold transition-colors">
            {l.label}
          </Link>
        </li>
      ))}
    </ul>
  </div>
);

const SocialLink = ({ icon, href, label }) => (
  <a href={href} aria-label={label} target="_blank" rel="noreferrer" className="btn-ghost-icon !w-9 !h-9">
    {icon}
  </a>
);
